import axiosInstance from "./axiosInstance";

export const getPublicBrands = async ({ signal } = {}) => {
  const { data } = await axiosInstance.get("/brands/public", { signal });
  return Array.isArray(data?.brands) ? data.brands : [];
};
